/**
 * Found this on StackOverflow (at the time, it was the 2nd answer with the highest overall score),
 * after testing in Regexr it appears to handle the edge cases we're seeing in production.
 * SO: https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
 */
export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
